/**
 * Megamenú de Categorías - JavaScript Mejorado
 * ============================================
 * 
 * Funcionalidades:
 * - Toggle del menú principal
 * - Cerrar al hacer click fuera
 * - Cerrar con tecla Escape
 * - Sincronizar altura del megamenú con el contenedor principal
 */

document.addEventListener('DOMContentLoaded', () => {
    // ============================================
    // 1. SELECCIÓN DE ELEMENTOS
    // ============================================
    const button = document.getElementById('btnCategories');
    const menuContent = document.getElementById('navCatContent');
    const container = document.querySelector('.categorias-header-pers');

    // Validación de existencia
    if (!button || !menuContent || !container) {
        console.warn('⚠️ Elementos del megamenú no encontrados');
        return;
    }

    // ============================================
    // 2. TOGGLE DEL MENÚ PRINCIPAL
    // ============================================
    button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        
        // Alternar estado
        button.setAttribute('aria-expanded', !isExpanded);
        menuContent.classList.toggle('show-cat');

        // Sincronizar altura del megamenú
        if (!isExpanded) {
            syncMegamenuHeight();
        }
    });

    // ============================================
    // 3. CERRAR AL HACER CLICK FUERA
    // ============================================
    document.addEventListener('click', (e) => {
        if (!container.contains(e.target)) {
            closeMenu();
        }
    });

    // ============================================
    // 4. CERRAR CON TECLA ESCAPE (Accesibilidad)
    // ============================================
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && menuContent.classList.contains('show-cat')) {
            closeMenu();
            button.focus(); // Devolver foco al botón
        }
    });

    // ============================================
    // 5. SINCRONIZAR ALTURA DEL MEGAMENÚ
    // ============================================
    function syncMegamenuHeight() {
        // Seleccionar todos los megamenús
        const megamenus = document.querySelectorAll('.dropdown-mega-menu2-cat');
        
        if (megamenus.length === 0) return;

        // Obtener altura del contenedor principal
        const navHeight = menuContent.offsetHeight;

        // Aplicar altura a cada megamenú
        megamenus.forEach(menu => {
            menu.style.minHeight = navHeight + 'px';
        });
    }

    // ============================================
    // 6. FUNCIÓN AUXILIAR: CERRAR MENÚ
    // ============================================
    function closeMenu() {
        menuContent.classList.remove('show-cat');
        button.setAttribute('aria-expanded', 'false');
    }

    // ============================================
    // 7. SINCRONIZAR ALTURA AL REDIMENSIONAR (OPCIONAL)
    // ============================================
    let resizeTimer;
    window.addEventListener('resize', () => {
        // Debounce para evitar múltiples llamadas
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            if (menuContent.classList.contains('show-cat')) {
                syncMegamenuHeight();
            }
        }, 250);
    });

    // ============================================
    // 8. SINCRONIZACIÓN INICIAL (por si acaso)
    // ============================================
    // Si el menú se abre por defecto o mediante otra lógica
    if (menuContent.classList.contains('show-cat')) {
        syncMegamenuHeight();
    }

    // ============================================
    // 9. MEJORA PARA MÓVIL (OPCIONAL)
    // ============================================
    // En móvil, agregar comportamiento de toggle al hacer click
    if (window.innerWidth < 992) {
        const mobileDropdowns = document.querySelectorAll('.dropdown-mega-menu-cat > a');
        
        mobileDropdowns.forEach(link => {
            link.addEventListener('click', (e) => {
                const parent = link.parentElement;
                const megamenu = parent.querySelector('.dropdown-mega-menu2-cat');
                
                if (megamenu) {
                    e.preventDefault();
                    
                    // Toggle del submenu en móvil
                    if (megamenu.style.display === 'block') {
                        megamenu.style.display = 'none';
                    } else {
                        // Cerrar otros submenu abiertos
                        document.querySelectorAll('.dropdown-mega-menu2-cat').forEach(m => {
                            m.style.display = 'none';
                        });
                        megamenu.style.display = 'block';
                    }
                }
            });
        });
    }
});
